export default __webpack_public_path__ + "static/news2-f6b0b4caa831c736a316fea69e377f94.png";